(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["arc-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
  var DEG = Math.PI / 180;

  function initArc(root) {
    if (!root || root.__neArcInit) return;
    root.__neArcInit = true;

    var stage = root.querySelector('[data-arc-stage]');
    if (!stage) return;
    var cards = Array.prototype.slice.call(stage.querySelectorAll('[data-arc-card]'));
    var n = cards.length;
    if (!n) return;

    var loop = root.hasAttribute('data-arc-loop');
    var nav = root.getAttribute('data-arc-nav') || 'arrows';
    var align = root.getAttribute('data-arc-align') || 'bottom';
    var active = Math.floor(n / 2);

    function num(name, fb) {
      var v = parseFloat(getComputedStyle(root).getPropertyValue(name));
      return isNaN(v) ? fb : v;
    }

    function render() {
      var R = num('--ne-arc-radius', 620);
      var center = num('--ne-arc-center', 0);
      var spread = num('--ne-arc-spread', 26);
      var scaleAmt = num('--ne-arc-scale-amt', 0.55);
      var isFan = root.classList.contains('ne-arc--orient-fan');
      var isFocus = root.classList.contains('ne-arc--scale-focus');
      var bottom = align === 'bottom';
      var H = root.clientHeight || 460;
      // apex card sits at the NON-aligned edge; cards curve toward the aligned edge
      var ch = (cards[active] && cards[active].offsetHeight) || (H * 0.6);
      var apexY = bottom ? (ch / 2 + center) : (H - ch / 2 + center);

      for (var i = 0; i < n; i++) {
        var d = i - active;
        if (loop) {
          if (d > n / 2) d -= n;
          else if (d < -n / 2) d += n;
        }
        var ad = Math.abs(d);
        var theta = d * spread * DEG;
        var x = R * Math.sin(theta);
        var drop = R * (1 - Math.cos(theta));           // travel toward the aligned edge
        var cy = bottom ? (apexY + drop) : (apexY - drop);
        var ay = cy - H / 2;                            // card CSS anchors at block centre
        var rot = isFan ? (bottom ? (d * spread) : (-d * spread)) : 0;
        var sc = isFocus ? (1 - scaleAmt * (1 - Math.pow(0.72, ad))) : 1;

        var c = cards[i];
        c.style.setProperty('--ax', x.toFixed(1) + 'px');
        c.style.setProperty('--ay', ay.toFixed(1) + 'px');
        c.style.setProperty('--arot', rot.toFixed(2) + 'deg');
        c.style.setProperty('--asc', sc.toFixed(3));
        c.style.setProperty('--az', String(100 - ad));
        if (ad > 6) c.setAttribute('data-arc-hidden', '');
        else c.removeAttribute('data-arc-hidden');
      }
      updateNav();
    }

    function clamp() {
      if (loop) {
        active = ((active % n) + n) % n;
      } else {
        if (active < 0) active = 0;
        if (active > n - 1) active = n - 1;
      }
    }

    function go(t) {
      active = t;
      clamp();
      render();
    }

    var prevBtn = root.querySelector('[data-arc-prev]');
    var nextBtn = root.querySelector('[data-arc-next]');
    function updateNav() {
      if (loop || !prevBtn || !nextBtn) return;
      if (active <= 0) prevBtn.setAttribute('disabled', ''); else prevBtn.removeAttribute('disabled');
      if (active >= n - 1) nextBtn.setAttribute('disabled', ''); else nextBtn.removeAttribute('disabled');
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { go(active - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(active + 1); });

    // Click a side card to bring it to focus (all nav modes)
    cards.forEach(function (c, i) {
      c.addEventListener('click', function (e) {
        if (i === active) return;
        if (root.__arcDragged) return;
        e.preventDefault();
        go(i);
      });
    });

    // --- Hover-edge nav (continuous, faster near the edge) ---
    if (nav === 'hover-edge') {
      var hoverDir = 0, hoverSpeed = 0, raf = 0, lastStep = 0;
      root.addEventListener('pointermove', function (e) {
        var r = root.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        if (px < 0.28) { hoverDir = -1; hoverSpeed = (0.28 - px) / 0.28; }
        else if (px > 0.72) { hoverDir = 1; hoverSpeed = (px - 0.72) / 0.28; }
        else { hoverDir = 0; }
      });
      root.addEventListener('pointerleave', function () { hoverDir = 0; });
      function tick(t) {
        if (hoverDir !== 0) {
          var interval = 520 - hoverSpeed * 400;
          if (t - lastStep >= interval) { go(active + hoverDir); lastStep = t; }
        }
        raf = requestAnimationFrame(tick);
      }
      raf = requestAnimationFrame(tick);
    }

    // --- Drag / swipe nav ---
    // 'drag' mode: drag with any pointer. 'arrows' mode: ALSO allow touch-swipe
    // (on mobile the arrows are hidden), so the arc stays navigable there. The
    // touch gate keeps desktop 'arrows' mode unchanged (click only, no mouse-drag).
    if (nav === 'drag' || nav === 'arrows') {
      var _dragTouchOnly = (nav === 'arrows');
      var down = false, startX = 0, moved = 0, startActive = 0;
      var stepPx = 90;
      stage.style.touchAction = 'pan-y';
      stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
      root.addEventListener('pointerdown', function (e) {
        if (_dragTouchOnly && e.pointerType !== 'touch') return;
        down = true; startX = e.clientX; moved = 0; startActive = active;
        root.__arcDragged = false;
        try { root.setPointerCapture(e.pointerId); } catch (err) {}
      });
      root.addEventListener('pointermove', function (e) {
        if (!down) return;
        moved = e.clientX - startX;
        if (Math.abs(moved) > 6) root.__arcDragged = true;
        var delta = Math.round(-moved / stepPx);
        go(startActive + delta);
      });
      function endDrag() {
        if (!down) return;
        down = false;
        setTimeout(function () { root.__arcDragged = false; }, 30);
      }
      root.addEventListener('pointerup', endDrag);
      root.addEventListener('pointercancel', endDrag);
    }

    // --- Scroll / wheel nav ---
    if (nav === 'scroll') {
      var accum = 0, lockUntil = 0;
      root.addEventListener('wheel', function (e) {
        var now = Date.now();
        var primary = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
        accum += primary;
        if (now < lockUntil) { e.preventDefault(); return; }
        if (Math.abs(accum) > 40) {
          go(active + (accum > 0 ? 1 : -1));
          accum = 0;
          lockUntil = now + 200;
        }
        e.preventDefault();
      }, { passive: false });
    }

    render();
    if (root.__arcRO) root.__arcRO.disconnect();
    root.__arcRO = new ResizeObserver(function () { render(); });
    root.__arcRO.observe(root);
  }

  function scan(scope) {
    var els = (scope || document).querySelectorAll('[data-arc]');
    Array.prototype.forEach.call(els, initArc);
  }

  window.neInitArcGalleries = scan;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:block:select', function (e) { scan(e.target); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["before-after-comparison"] && !Shopify.designMode) return;
  try {
    (function () {
    function initBA(root) {
      (root || document).querySelectorAll('[data-ba-slider]').forEach(function (el) {
        if (el.__baInit) return;
        el.__baInit = true;

        var viewport = el.querySelector('.ne-ba-compare__viewport');
        var beforeEl = el.querySelector('[data-ba-before]');
        var afterEl  = el.querySelector('[data-ba-after]');
        var divider  = el.querySelector('[data-ba-divider]');
        var handle   = el.querySelector('[data-ba-handle]');
        if (!viewport || !afterEl || !divider) return;

        var startPct = parseFloat(el.getAttribute('data-start'));
        if (isNaN(startPct)) startPct = 50;
        var currentPct = startPct;
        var dragging = false;

        function setPct(pct) {
          pct = Math.max(0, Math.min(100, pct));
          currentPct = pct;
          /* Inverse clip pair: before keeps left X%, after keeps right (100-X)%
             — they never overlap, so transparent pixels in either image
             never reveal the other layer underneath. */
          if (afterEl)  afterEl.style.clipPath  = 'inset(0 0 0 ' + pct + '%)';
          if (beforeEl) beforeEl.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
          divider.style.left = pct + '%';
          if (handle) handle.setAttribute('aria-valuenow', Math.round(pct));
        }

        function pctFromX(clientX) {
          var rect = viewport.getBoundingClientRect();
          if (rect.width === 0) return currentPct;
          return ((clientX - rect.left) / rect.width) * 100;
        }

        /* Pointer (covers mouse + touch + pen). */
        function onPointerDown(e) {
          dragging = true;
          el.setAttribute('data-ba-dragging', '1');
          setPct(pctFromX(e.clientX));
          if (e.target && e.target.setPointerCapture) {
            try { e.target.setPointerCapture(e.pointerId); } catch (_) {}
          }
          e.preventDefault();
        }
        function onPointerMove(e) {
          if (!dragging) return;
          setPct(pctFromX(e.clientX));
        }
        function onPointerUp() {
          dragging = false;
          el.removeAttribute('data-ba-dragging');
        }

        viewport.addEventListener('pointerdown', onPointerDown);
        document.addEventListener('pointermove', onPointerMove);
        document.addEventListener('pointerup', onPointerUp);
        document.addEventListener('pointercancel', onPointerUp);

        /* Keyboard. */
        if (handle) {
          handle.addEventListener('keydown', function (e) {
            var step = e.shiftKey ? 10 : 2;
            if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
              setPct(currentPct - step); e.preventDefault();
            } else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
              setPct(currentPct + step); e.preventDefault();
            } else if (e.key === 'Home') {
              setPct(0); e.preventDefault();
            } else if (e.key === 'End') {
              setPct(100); e.preventDefault();
            }
          });
        }

        /* Initial paint (in case Liquid inline clip-path didn't take). */
        setPct(startPct);
      });
    }

    document.addEventListener('DOMContentLoaded', function () { initBA(document); });
    document.addEventListener('shopify:section:load',  function (e) { initBA(e.target); });
    document.addEventListener('shopify:block:select',  function (e) { initBA(e.target.parentElement || document); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["button"] && !Shopify.designMode) return;
  try {
    /* Magnetic buttons — one global handler for every button block with the
   magnet option on (data-ne-magnet), anywhere in the theme. The button leans
   toward the cursor when it's within range; resets when the cursor leaves.
   prefers-reduced-motion → disabled. */
(function () {
  if (window.__neBtnMagnet) return;
  window.__neBtnMagnet = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var RADIUS = 130;
  var btns = [];
  function refresh() {
    btns = Array.prototype.slice.call(document.querySelectorAll('[data-ne-magnet]'));
  }
  refresh();

  var raf = null, mx = 0, my = 0;
  function tick() {
    raf = null;
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var r = b.getBoundingClientRect();
      if (!r.width) continue;
      var dx = mx - (r.left + r.width / 2);
      var dy = my - (r.top + r.height / 2);
      var dist = Math.sqrt(dx * dx + dy * dy);
      if (dist < RADIUS) {
        var strength = (parseFloat(getComputedStyle(b).getPropertyValue('--ne-magnet')) || 40) / 100;
        var pull = (1 - dist / RADIUS) * strength * 0.5;
        b.style.transform = 'translate(' + (dx * pull).toFixed(1) + 'px,' + (dy * pull).toFixed(1) + 'px)';
      } else if (b.style.transform) {
        b.style.transform = '';
      }
    }
  }
  window.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    mx = e.clientX; my = e.clientY;
    if (!raf) raf = requestAnimationFrame(tick);
  }, { passive: true });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-items"] && !Shopify.designMode) return;
  try {
    /* AJAX cart updates: remove + qty-change without page reload.
     Pattern (mirrors snippets/cart-drawer.liquid changeQuantity):
       1. POST /cart/change.js with { line, quantity }
       2. GET  /cart?sections=main → fresh section HTML
       3. Swap .ne-cart innerHTML, re-bind handlers, fire ne:cart-updated
       Header counter + cart-drawer + sticky-bar all listen to that event.
     Edge cases:
       - quantity=0  → line removed; new HTML shifts subsequent line numbers,
         re-bind reads forloop.index from server-rendered data-line attrs.
       - last item removed → server returns empty-state markup; same swap path.
       - fetch fails → loading class cleared, console.error, no UI revert
         (acceptable: optimistic input reverts on next user action). */
  (function() {
    var SECTION_ID = 'main'; // matches templates/cart.json section key
    var queue = Promise.resolve();
    var inFlight = 0;
    var needsReload = false;
    var qtyDebounce;

    function findSection() { return document.querySelector('.ne-cart'); }

    function setLoading(state) {
      var s = findSection();
      if (s) s.classList.toggle('ne-cart--loading', state);
    }

    function syncSubtotal(cart) {
      document.querySelectorAll('[data-cart-subtotal]').forEach(function(el) {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          el.textContent = Shopify.formatMoney(cart.total_price);
        } else {
          el.textContent = '$' + (cart.total_price / 100).toFixed(2);
        }
      });
    }

    function refetchSection() {
      return fetch('/cart?sections=' + SECTION_ID, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function(r) { return r.json(); })
        .then(function(sections) {
          var html = sections && sections[SECTION_ID];
          if (!html) return null;
          var oldCart = findSection();
          if (!oldCart) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCart = doc.querySelector('.ne-cart');
          if (!newCart) return null;
          oldCart.innerHTML = newCart.innerHTML;
          oldCart.className = newCart.className;
          bindAll();
          return oldCart;
        });
    }

    /* Queue mutations so concurrent removes/qty-changes don't race.
       Pre-Sprint-1 used line-numbers + a `pending` flag; rapid clicks
       were silently dropped AND line numbers shift after the first
       remove (server line 2 → line 1) so subsequent calls targeted
       the wrong row. Now: each call gets queued behind the prior;
       targeting is by line-item KEY which is stable across removes. */
    function changeCart(payload) {
      setLoading(true);
      inFlight++;
      var p = queue.then(function() {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload)
        })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            syncSubtotal(cart);
            document.querySelectorAll('[data-cart-count], [data-cart-drawer-count]').forEach(function(el) {
              el.textContent = cart.item_count;
              el.style.display = (cart.item_count > 0) ? '' : 'none';
            });
            /* Last item removed: cart.liquid has two branches based on
               cart.item_count > 0 (form vs empty-state). The section
               refetch can lag behind /cart/change.js commit by a tick
               and may return the form branch with empty rows instead
               of the empty-state. Hard reload guarantees the user
               lands on a clean empty-state with image + CTA. */
            if (cart.item_count === 0) needsReload = true;
            return cart;
          });
      });
      queue = p.catch(function() { /* drop, keep chain alive */ });
      p.catch(function(err) { console.error('[cart-items] update failed:', err); })
        .then(function() {
          inFlight--;
          if (inFlight !== 0) return;
          // Cart drained to 0 → full reload (clean empty-state)
          if (needsReload) {
            window.location.reload();
            return;
          }
          // After ALL queued mutations settle, refetch once + dispatch.
          // Wrap in catch so a refetch failure doesn't leave loading state stuck.
          return refetchSection()
            .catch(function(err) { console.error('[cart-items] refetch failed:', err); })
            .then(function() {
              setLoading(false);
              document.dispatchEvent(new CustomEvent('ne:cart-rerendered', { detail: {} }));
            });
        });
      return p;
    }

    function rowFromEl(el) { return el.closest('[data-cart-item]'); }
    function keyFromRow(row) { return row ? row.getAttribute('data-key') : null; }

    function bindQtySpinner(scope) {
      (scope || document).querySelectorAll('[data-qty-change]').forEach(function(btn) {
        if (btn.dataset.neBound) return;
        btn.dataset.neBound = '1';
        btn.addEventListener('click', function() {
          var spinner = btn.closest('.ne-cart-items__qty-spinner');
          if (!spinner) return;
          var input = spinner.querySelector('[data-qty-input]');
          if (!input) return;
          var row = rowFromEl(btn);
          var key = keyFromRow(row);
          if (!key) return;
          var val = parseInt(input.value, 10) || 0;
          var change = parseInt(btn.dataset.qtyChange, 10);
          var newQty = Math.max(0, val + change);
          input.value = newQty; // optimistic
          clearTimeout(qtyDebounce);
          qtyDebounce = setTimeout(function() { changeCart({ id: key, quantity: newQty }); }, 250);
        });
      });
    }

    function bindQtyInput(scope) {
      (scope || document).querySelectorAll('[data-qty-input]').forEach(function(input) {
        if (input.dataset.neQtyBound) return;
        input.dataset.neQtyBound = '1';
        input.addEventListener('change', function() {
          var key = keyFromRow(rowFromEl(input));
          if (!key) return;
          var qty = Math.max(0, parseInt(input.value, 10) || 0);
          changeCart({ id: key, quantity: qty });
        });
      });
    }

    function bindQtySelect(scope) {
      (scope || document).querySelectorAll('.ne-cart-items__qty-select').forEach(function(sel) {
        if (sel.dataset.neQtyBound) return;
        sel.dataset.neQtyBound = '1';
        sel.addEventListener('change', function() {
          var key = keyFromRow(rowFromEl(sel));
          if (!key) return;
          changeCart({ id: key, quantity: parseInt(sel.value, 10) });
        });
      });
    }

    function bindRemove(scope) {
      (scope || document).querySelectorAll('[data-cart-remove]').forEach(function(link) {
        if (link.dataset.neRemoveBound) return;
        link.dataset.neRemoveBound = '1';
        link.addEventListener('click', function(e) {
          e.preventDefault();
          var row = rowFromEl(link);
          var key = keyFromRow(row);
          if (!key) return;
          if (row) {
            /* Optimistic UI: hide the row immediately so the user sees
               instant feedback. refetchSection will rewrite the whole
               cart-items innerHTML once /cart/change.js + section
               refetch resolve. If anything in that chain fails, the
               row stays hidden — matches what a manual reload would
               show (server already removed it). */
            row.classList.add('ne-cart-items__row--removing');
            row.style.display = 'none';
          }
          changeCart({ id: key, quantity: 0 });
        });
      });
    }

    function bindAll(scope) {
      bindQtySpinner(scope);
      bindQtyInput(scope);
      bindQtySelect(scope);
      bindRemove(scope);
    }

    bindAll();
    document.addEventListener('shopify:section:load', function(e) { bindAll(e.target); });
    document.addEventListener('shopify:block:select', function(e) { bindAll(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-summary"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Mobile sticky cart-summary bar — mirrors snippets/sticky-product-bar.liquid.

       Architecture:
       - The bar is rendered as a SEPARATE <aside data-sticky-cart-bar>
         element in Liquid (only when mobile_sticky_position=bottom).
       - On init, the bar is body-mounted ONCE (Rule 146 — sidesteps
         transform/will-change ancestor traps).
       - Visibility is toggled via [data-sticky-state="visible"|"hidden"]
         attribute. The DOM never moves after the initial mount → no
         flicker, no duplicates during customizer live-preview.
       - IntersectionObserver watches the in-flow summary (the original
         .ne-cart-summary inside cart-section). When it scrolls into
         view (customer reached the bottom), bar hides. When it leaves
         the viewport, bar shows.
       - On resize, the bar's left/width is recalculated to match the
         cart section's content box (unless --mobile-fullwidth is set).
    */

    var mq = window.matchMedia('(max-width: 749px)');

    function findCartSection() { return document.querySelector('.ne-cart'); }
    function findInFlowSummary() {
      // The non-bar summary inside the cart section
      return document.querySelector('.ne-cart .ne-cart-summary:not([data-sticky-cart-bar])');
    }

    function applySectionWidth(bar) {
      if (bar.classList.contains('ne-cart-summary--mobile-fullwidth')) {
        bar.style.left = '';
        bar.style.right = '';
        bar.style.width = '';
        return;
      }
      var section = findCartSection();
      if (!section) return;
      var rect = section.getBoundingClientRect();
      var styles = window.getComputedStyle(section);
      var pl = parseFloat(styles.paddingLeft) || 0;
      var pr = parseFloat(styles.paddingRight) || 0;
      bar.style.left = (rect.left + pl) + 'px';
      bar.style.right = 'auto';
      bar.style.width = Math.max(0, rect.width - pl - pr) + 'px';
    }

    function showBar(bar) {
      // Recalc width before transition starts so the visible bar
      // is correctly positioned even if mobile media-query just
      // engaged and section padding changed.
      applySectionWidth(bar);
      bar.setAttribute('data-sticky-state', 'visible');
      bar.setAttribute('aria-hidden', 'false');
      /* inert geht mit aria-hidden im Gleichschritt. Ohne das bleibt die Leiste
         im verborgenen Zustand ein Tabstopp: sie versteckt sich nur mit
         transform und pointer-events, und beides nimmt ein Element NICHT aus
         der Tabreihenfolge. Ein Tastaturnutzer landete dort auf Knopf und Link,
         die der Screenreader zugleich nicht kennt (WCAG 4.1.2, Rule 645). */
      bar.removeAttribute('inert');
      var section = findCartSection();
      if (section) section.classList.add('ne-cart--has-sticky-bar');
    }
    function hideBar(bar) {
      bar.setAttribute('data-sticky-state', 'hidden');
      bar.setAttribute('aria-hidden', 'true');
      bar.setAttribute('inert', '');
      var section = findCartSection();
      if (section) section.classList.remove('ne-cart--has-sticky-bar');
    }

    function setupBar(bar) {
      if (bar._neStickyInitDone) return;
      bar._neStickyInitDone = true;

      // Body-mount once — never move again
      bar.dataset.stickyMounted = '1';
      if (bar.parentNode !== document.body) {
        document.body.appendChild(bar);
      }
      applySectionWidth(bar);

      // Initial state: hidden until observer determines visibility
      hideBar(bar);

      // Watch the in-flow summary
      var observed = findInFlowSummary();
      if (!observed || !('IntersectionObserver' in window)) {
        // Fallback: just show the bar always if no observer/target
        showBar(bar);
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!mq.matches) {
            hideBar(bar);
            return;
          }
          if (entry.isIntersecting) {
            // In-flow summary visible → hide bar so customer sees the full version
            hideBar(bar);
          } else {
            // In-flow summary not in viewport → show bar as quick-checkout
            showBar(bar);
          }
        });
      }, { threshold: 0 });
      io.observe(observed);
      bar._neObserver = io;
      bar._neObservedTarget = observed;

      // Forward bar's checkout button to the main cart form (so qty
      // updates from the items block submit alongside the checkout).
      var checkoutBtn = bar.querySelector('[data-sticky-bar-checkout]');
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var mainForm = document.querySelector('[data-cart-form]');
          if (mainForm) {
            // Inject a hidden checkout button so Shopify routes to /checkout
            var hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'checkout';
            hidden.value = '';
            mainForm.appendChild(hidden);
            mainForm.submit();
          } else {
            // Fallback: direct navigation
            window.location.href = '/checkout';
          }
        });
      }
    }

    function teardownBar(bar) {
      if (!bar) return;
      if (bar._neObserver) {
        bar._neObserver.disconnect();
        bar._neObserver = null;
      }
      if (bar.parentNode === document.body) {
        bar.parentNode.removeChild(bar);
      }
      bar._neStickyInitDone = false;
    }

    function purgeStaleBars() {
      // Remove any body-mounted bars whose anchor is no longer in document
      // (left over from previous customizer renders).
      var bodyBars = document.body.querySelectorAll(':scope > [data-sticky-cart-bar]');
      var section = findCartSection();
      bodyBars.forEach(function (bar) {
        // If section gone OR there's a fresher bar in section that hasn't been mounted yet,
        // remove this stale one.
        var freshBar = section ? section.querySelector('[data-sticky-cart-bar]') : null;
        if (!section || (freshBar && freshBar !== bar)) {
          teardownBar(bar);
        }
      });
    }

    function init() {
      purgeStaleBars();
      var bar = document.querySelector('[data-sticky-cart-bar]');
      if (!bar) return;
      if (mq.matches) {
        setupBar(bar);
      } else {
        teardownBar(bar);
      }
    }

    function refreshWidth() {
      document.body.querySelectorAll(':scope > [data-sticky-cart-bar]').forEach(applySectionWidth);
    }

    init();
    mq.addEventListener('change', init);
    window.addEventListener('resize', refreshWidth, { passive: true });
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', purgeStaleBars);
    document.addEventListener('shopify:block:select', init);
    /* AJAX cart updates from cart-items refetch the section HTML in place
       (no Shopify section:load fires). Re-init so the body-mounted sticky
       bar finds the new in-flow summary anchor. ne:cart-rerendered is the
       cart-items-internal event; ne:cart-updated covers external triggers
       (Schnellkauf aus einem JS-Raster etc.) so the bar stays in sync either way. */
    document.addEventListener('ne:cart-rerendered', init);
    document.addEventListener('ne:cart-updated', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-banner"] && !Shopify.designMode) return;
  try {
    (function() {
    function initParallax(banner) {
      if (banner.dataset.parallaxBound === '1') return;
      banner.dataset.parallaxBound = '1';

      var img = banner.querySelector('.ne-collection-banner__image');
      if (!img) return;

      // Skip parallax when the image is focal-POSITIONED (mounted glass / Fit):
      // it owns img.style-independent transform for centring, and the parallax
      // transform would clobber that offset and fling the image off-centre.
      if (banner.classList.contains('ne-collection-banner--fit-fit') ||
          (banner.classList.contains('ne-collection-banner--surf-banner') &&
           banner.classList.contains('ne-collection-banner--panel-glass'))) {
        return;
      }

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (reduceMotion || isMobile) return;

      var ticking = false;
      function update() {
        var rect = banner.getBoundingClientRect();
        var vh = window.innerHeight || 800;
        if (rect.bottom < 0 || rect.top > vh) { ticking = false; return; }
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        var translate = Math.max(-30, Math.min(30, progress * -20));
        img.style.transform = 'translateY(' + translate.toFixed(2) + 'px) scale(1.06)';
        ticking = false;
      }
      function onScroll() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-collection-banner].ne-collection-banner--parallax').forEach(initParallax);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function(e) { initAll(e.target); });
    document.addEventListener('shopify:block:select', function(e) {
      if (e.target && e.target.matches && e.target.matches('[data-collection-banner]')) {
        initParallax(e.target);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-grid"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCarousels(root) {
      (root || document).querySelectorAll('[data-cg-carousel]').forEach(function (carousel) {
        if (carousel.__cgInit) return;
        carousel.__cgInit = true;
        var track = carousel.querySelector('[data-cg-track]');
        var prev = carousel.querySelector('[data-cg-prev]');
        var next = carousel.querySelector('[data-cg-next]');
        if (!track) return;

        function step() {
          var slide = track.querySelector('.ne-collection-card');
          if (!slide) return track.clientWidth;
          var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0', 10);
          return slide.offsetWidth + gap;
        }
        // scrollTo (not scrollBy) — Rule 141.
        if (prev) prev.addEventListener('click', function () {
          track.scrollTo({ left: Math.max(track.scrollLeft - step(), 0), behavior: 'smooth' });
        });
        if (next) next.addEventListener('click', function () {
          track.scrollTo({ left: Math.min(track.scrollLeft + step(), track.scrollWidth - track.clientWidth), behavior: 'smooth' });
        });

        // Hide arrows when all cards fit without overflow. Re-evaluated
        // on resize because columns_mobile + breakpoints change visible
        // count. Also re-checked after each image load so the initial
        // (no-image) measurement isn't false-positive.
        function syncArrows() {
          var overflow = track.scrollWidth - track.clientWidth > 2;
          carousel.classList.toggle('ne-cg--no-overflow', !overflow);
        }
        syncArrows();
        window.addEventListener('resize', syncArrows);
        track.querySelectorAll('img').forEach(function (img) {
          if (!img.complete) img.addEventListener('load', syncArrows, { once: true });
        });

        // Off-screen visibility hide (Rule 152) — keeps shadow from
        // leaking into the visible track edge. visibility:hidden hides
        // the element AND its shadow without breaking layout/scroll.
        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              entry.target.style.visibility = entry.isIntersecting ? 'visible' : 'hidden';
            });
          }, { root: track, threshold: 0.01 });
          track.querySelectorAll('.ne-collection-card').forEach(function (card) {
            observer.observe(card);
          });
        }
      });
    }
    document.addEventListener('DOMContentLoaded', function () { initCarousels(document); });
    document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });
    document.addEventListener('shopify:block:select', function (e) { initCarousels(e.target.parentElement || document); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCountdownBlocks(root) {
      (root || document).querySelectorAll('[data-cd-timer]').forEach(function (el) {
        if (el.__cdInit) return;
        el.__cdInit = true;

        var iso = el.getAttribute('data-target-iso') || '';
        var targetMs = new Date(iso).getTime();
        var expiredMessage = el.getAttribute('data-expired-message') || 'This event has ended';

        if (isNaN(targetMs)) return;

        var dEl = el.querySelector('[data-cd-days]');
        var hEl = el.querySelector('[data-cd-hours]');
        var mEl = el.querySelector('[data-cd-minutes]');
        var sEl = el.querySelector('[data-cd-seconds]');
        var timer = null;

        function pad(n) { return n < 10 ? '0' + n : '' + n; }

        function tick() {
          var diff = targetMs - Date.now();
          if (diff <= 0) {
            if (timer) { clearInterval(timer); timer = null; }
            // Build via textContent — expiredMessage came back decoded from the
            // attribute, so concatenating into innerHTML would re-parse it as HTML.
            el.textContent = '';
            var _exp = document.createElement('p');
            _exp.className = 'ne-cd-timer__expired';
            _exp.textContent = expiredMessage;
            el.appendChild(_exp);
            return;
          }
          var days    = Math.floor(diff / 86400000);
          var hours   = Math.floor((diff % 86400000) / 3600000);
          var minutes = Math.floor((diff % 3600000) / 60000);
          var seconds = Math.floor((diff % 60000) / 1000);
          if (dEl) dEl.textContent = pad(days);
          if (hEl) hEl.textContent = pad(hours);
          if (mEl) mEl.textContent = pad(minutes);
          if (sEl) sEl.textContent = pad(seconds);
        }

        tick();
        timer = setInterval(tick, 1000);
      });
    }
    document.addEventListener('DOMContentLoaded', function () { initCountdownBlocks(document); });
    document.addEventListener('shopify:section:load', function (e) { initCountdownBlocks(e.target); });
    document.addEventListener('shopify:block:select', function (e) { initCountdownBlocks(e.target.parentElement || document); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["footer-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Sync <details data-fm-accordion> open state to viewport: closed
       on mobile (≤749), open on desktop. Re-evaluates on resize. */
    function syncAccordions() {
      var isMobile = window.innerWidth <= 749;
      document.querySelectorAll('[data-fm-accordion]').forEach(function (el) {
        if (isMobile) {
          if (el.hasAttribute('open')) el.removeAttribute('open');
        } else {
          if (!el.hasAttribute('open')) el.setAttribute('open', '');
        }
      });
    }
    var _resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(_resizeTimer);
      _resizeTimer = setTimeout(syncAccordions, 120);
    });
    document.addEventListener('DOMContentLoaded', syncAccordions);
    document.addEventListener('shopify:section:load', syncAccordions);
    document.addEventListener('shopify:block:select', syncAccordions);
    /* Run immediately for already-loaded DOM */
    if (document.readyState !== 'loading') syncAccordions();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gallery-grid"] && !Shopify.designMode) return;
  try {
    (function () {
    function initGalleryGrid(root) {
      (root || document).querySelectorAll('[data-gallery-grid]').forEach(function (gg) {
        if (gg.__ggInit) return;
        gg.__ggInit = true;

        // ───── Carousel ─────
        var carousel = gg.querySelector('[data-gg-carousel]');
        if (carousel) initCarousel(gg, carousel);

        // ───── Lightbox ─────
        if (gg.classList.contains('ne-gg--lightbox')) initLightbox(gg);
      });
    }

    function initCarousel(gg, carousel) {
      var track = carousel.querySelector('[data-gg-track]');
      var nav = carousel.querySelector('[data-gg-nav]');
      var prev = carousel.querySelector('[data-gg-prev]');
      var next = carousel.querySelector('[data-gg-next]');
      if (!track) return;

      // Hide off-screen gallery items so their box-shadow doesn't leak
      // into the visible track area. visibility:hidden hides the
      // element AND its shadow without affecting layout/scroll metrics.
      // Items are inside .shopify-block wrappers (display:contents);
      // observe the actual .ne-block-image-wrap for visibility toggling.
      if ('IntersectionObserver' in window) {
        var visObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            entry.target.style.visibility = entry.isIntersecting ? 'visible' : 'hidden';
          });
        }, { root: track, threshold: 0.01 });
        track.querySelectorAll('.ne-block-image-wrap').forEach(function (wrap) {
          visObserver.observe(wrap);
        });
      }

      var loop = carousel.getAttribute('data-gg-loop') === '1';

      function step() {
        // First child is .shopify-block (display:contents has no box;
        // Rule 115). Drill into the actual image-wrap to measure.
        var node = track.firstElementChild;
        var measured = node && node.querySelector ? node.querySelector('.ne-block-image-wrap') : null;
        var w = measured ? measured.getBoundingClientRect().width
                         : (node ? node.getBoundingClientRect().width : track.clientWidth);
        var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0', 10);
        return Math.max(1, w + gap);
      }

      function syncNav() {
        if (!nav) return;
        if (loop && track.children.length > 1) { nav.hidden = false; return; }
        var overflow = track.scrollWidth - track.clientWidth > 2;
        nav.hidden = !overflow;
      }
      syncNav();
      window.addEventListener('resize', syncNav);
      track.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', syncNav, { once: true });
      });

      var isEditor = !!(window.Shopify && window.Shopify.designMode);
      var rotateLoop = loop && !isEditor;

      function atStart() { return track.scrollLeft <= 2; }
      function atEnd()   { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; }
      function gapPx()   { return parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0', 10); }

      var isRotating = false;
      function domRotate(direction) {
        if (isRotating) return false;
        var isForward = direction === 'forward';
        var node = isForward ? track.firstElementChild : track.lastElementChild;
        if (!node) return false;
        if (direction !== 'eager-backward') {
          var tRect = track.getBoundingClientRect();
          var nRect = node.getBoundingClientRect();
          var offScreen = isForward
            ? nRect.right <= tRect.left + 1
            : nRect.left  >= tRect.right - 1;
          if (!offScreen) return false;
        }
        var measured = node.querySelector ? node.querySelector('.ne-block-image-wrap') : null;
        var w = (measured ? measured.offsetWidth : node.offsetWidth) + gapPx();
        isRotating = true;
        var prevBehavior = track.style.scrollBehavior;
        var prevSnap = track.style.scrollSnapType;
        track.style.scrollBehavior = 'auto';
        track.style.scrollSnapType = 'none';
        if (isForward) {
          track.appendChild(node);
          track.scrollLeft -= w;
        } else {
          track.insertBefore(node, track.firstElementChild);
          track.scrollLeft += w;
        }
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            track.style.scrollBehavior = prevBehavior;
            track.style.scrollSnapType = prevSnap;
            isRotating = false;
          });
        });
        return true;
      }

      if (rotateLoop) {
        function onScrollSettled() {
          while (domRotate('forward'))  { /* drain */ }
          while (domRotate('backward')) { /* drain */ }
          syncNav();
        }
        if ('onscrollend' in window) {
          track.addEventListener('scrollend', onScrollSettled);
        } else {
          var t = null;
          track.addEventListener('scroll', function () {
            if (t) clearTimeout(t);
            t = setTimeout(onScrollSettled, 260);
          }, { passive: true });
        }
      }

      function targetNext() { return Math.min(track.scrollLeft + step(), track.scrollWidth - track.clientWidth); }
      function targetPrev() { return Math.max(track.scrollLeft - step(), 0); }

      if (prev) prev.addEventListener('click', function () {
        if (rotateLoop && atStart()) {
          domRotate('eager-backward');
          track.scrollTo({ left: track.scrollLeft - step(), behavior: 'smooth' });
        } else if (loop && atStart()) {
          track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        } else {
          track.scrollTo({ left: targetPrev(), behavior: 'smooth' });
        }
      });
      if (next) next.addEventListener('click', function () {
        if (rotateLoop) {
          track.scrollTo({ left: track.scrollLeft + step(), behavior: 'smooth' });
        } else if (loop && atEnd()) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollTo({ left: targetNext(), behavior: 'smooth' });
        }
      });

      var autoplaySec = parseInt(carousel.getAttribute('data-gg-autoplay') || '0', 10);
      if (autoplaySec > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var timer = null;
        function stop()  { if (timer) { clearInterval(timer); timer = null; } }
        function tick() {
          if (rotateLoop) {
            track.scrollTo({ left: track.scrollLeft + step(), behavior: 'smooth' });
            return;
          }
          if (atEnd()) {
            if (loop) track.scrollTo({ left: 0, behavior: 'smooth' });
            else stop();
          } else {
            track.scrollTo({ left: targetNext(), behavior: 'smooth' });
          }
        }
        function play() { stop(); timer = setInterval(tick, autoplaySec * 1000); }
        carousel.addEventListener('mouseenter', stop);
        carousel.addEventListener('mouseleave', play);
        carousel.addEventListener('focusin', stop);
        carousel.addEventListener('focusout', play);
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) stop(); else play();
        });
        play();
      }
    }

    function initLightbox(gg) {
      var lb = gg.querySelector('[data-gg-lightbox]');
      if (!lb) return;
      // Re-parent to <body> so position:fixed escapes any ancestor with
      // transform/filter/will-change/contain (Rule 47 — those create
      // their own containing block and trap the fixed-positioned dialog
      // inside the section, clipping it to the section's bounds).
      if (lb.parentNode !== document.body) {
        document.body.appendChild(lb);
      }
      var img = lb.querySelector('[data-gg-lb-image]');
      var cap = lb.querySelector('[data-gg-lb-caption]');
      var counter = lb.querySelector('[data-gg-lb-counter]');
      var btnClose = lb.querySelector('[data-gg-lb-close]');
      var btnPrev = lb.querySelector('[data-gg-lb-prev]');
      var btnNext = lb.querySelector('[data-gg-lb-next]');

      // Collect every image-wrap that's NOT already wrapped in a link
      // (link wins over lightbox so users can keep their existing
      // navigation behavior).
      var wraps = Array.prototype.slice.call(gg.querySelectorAll('.ne-block-image-wrap'));
      var entries = [];
      wraps.forEach(function (wrap) {
        if (wrap.querySelector('a.ne-block-image__link')) return;
        var imgEl = wrap.querySelector('.ne-block-image__img');
        if (!imgEl || imgEl.classList.contains('ne-block-image__img--placeholder')) return;
        var capEl = wrap.querySelector('.ne-block-image__caption');
        entries.push({
          wrap: wrap,
          src: imgEl.currentSrc || imgEl.src,
          srcset: imgEl.srcset || '',
          alt: imgEl.alt || '',
          caption: capEl ? capEl.textContent.trim() : ''
        });
      });
      if (!entries.length) {
        // Nothing to lightbox — strip the dialog.
        lb.parentNode && lb.parentNode.removeChild(lb);
        return;
      }

      var index = 0;

      // Build the thumbnail strip from the collected entries (mirrors the
      // product lightbox). Only when there's more than one image.
      var thumbsWrap = lb.querySelector('[data-gg-lb-thumbs]');
      var thumbBtns = [];
      if (thumbsWrap && entries.length > 1) {
        entries.forEach(function (entry, i) {
          var tb = document.createElement('button');
          tb.type = 'button';
          tb.className = 'ne-gg__lb-thumb';
          tb.setAttribute('aria-label', 'View image ' + (i + 1));
          var ti = document.createElement('img');
          ti.src = entry.src;
          ti.alt = entry.alt || '';
          ti.loading = 'lazy';
          tb.appendChild(ti);
          tb.addEventListener('click', function () { show(i); });
          thumbsWrap.appendChild(tb);
          thumbBtns.push(tb);
        });
        thumbsWrap.hidden = false;
      }

      function fullSrc(entry) {
        // Prefer the largest source from srcset when available;
        // otherwise fall back to the rendered src.
        if (!entry.srcset) return entry.src;
        var best = entry.src;
        var bestW = 0;
        entry.srcset.split(',').forEach(function (s) {
          var parts = s.trim().split(/\s+/);
          var url = parts[0];
          var w = parts[1] ? parseInt(parts[1], 10) : 0;
          if (w > bestW) { bestW = w; best = url; }
        });
        return best;
      }

      function show(i) {
        index = (i + entries.length) % entries.length;
        var entry = entries[index];
        img.src = fullSrc(entry);
        img.alt = entry.alt;
        if (entry.caption) {
          cap.textContent = entry.caption;
          cap.hidden = false;
        } else {
          cap.textContent = '';
          cap.hidden = true;
        }
        if (counter) {
          if (entries.length > 1) {
            counter.textContent = (index + 1) + ' / ' + entries.length;
            counter.hidden = false;
          } else {
            counter.hidden = true;
          }
        }
        for (var ti = 0; ti < thumbBtns.length; ti++) {
          thumbBtns[ti].classList.toggle('ne-gg__lb-thumb--active', ti === index);
        }
      }
      function next() { show(index + 1); }
      function prev() { show(index - 1); }

      function open(i) {
        show(i);
        lb.hidden = false;
        requestAnimationFrame(function () { lb.classList.add('is-visible'); });
        document.body.style.overflow = 'hidden';
      }
      function close() {
        lb.classList.remove('is-visible');
        setTimeout(function () {
          lb.hidden = true;
          img.src = '';
          document.body.style.overflow = '';
        }, 250);
      }

      entries.forEach(function (entry, i) {
        var card = entry.wrap.querySelector('.ne-block-image');
        if (!card) return;
        card.setAttribute('role', 'button');
        card.setAttribute('tabindex', '0');
        card.setAttribute('aria-label', 'Open image' + (entry.alt ? ': ' + entry.alt : ''));
        card.addEventListener('click', function (e) {
          e.preventDefault();
          open(i);
        });
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            open(i);
          }
        });
      });

      if (btnClose) btnClose.addEventListener('click', close);
      if (btnPrev) btnPrev.addEventListener('click', prev);
      if (btnNext) btnNext.addEventListener('click', next);
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') prev();
        else if (e.key === 'ArrowRight') next();
      });

      // Touch swipe — left/right beyond threshold paginates. Vertical
      // swipes are ignored so the user can still scroll on tall images.
      var tStartX = 0, tStartY = 0, tActive = false;
      var SWIPE_THRESHOLD = 50;
      lb.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { tActive = false; return; }
        tStartX = e.touches[0].clientX;
        tStartY = e.touches[0].clientY;
        tActive = true;
      }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (!tActive) return;
        tActive = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - tStartX;
        var dy = t.clientY - tStartY;
        if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;
        if (dx < 0) next(); else prev();
      }, { passive: true });

      // Mouse wheel — horizontal trackpad gestures + vertical wheel both
      // paginate. Throttled so a single gesture only advances once.
      var wheelLock = false;
      lb.addEventListener('wheel', function (e) {
        if (wheelLock) return;
        var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
        if (Math.abs(d) < 10) return;
        wheelLock = true;
        if (d > 0) next(); else prev();
        setTimeout(function () { wheelLock = false; }, 350);
      }, { passive: true });
    }

    document.addEventListener('DOMContentLoaded', function () { initGalleryGrid(document); });
    document.addEventListener('shopify:section:load', function (e) { initGalleryGrid(e.target); });
    document.addEventListener('shopify:block:select', function (e) { initGalleryGrid(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    /* Quantity stepper buttons. Variant-id sync is handled by the section's
     JS (it listens to [data-option-index] change events on the variant
     picker block and writes the matched id into [data-variant-id-input]). */
  (function() {
    /* Gift-card recipient toggle: reveal fields + enable inputs only when the
       buyer opts to send as a gift, so they never submit for a self-purchase.
       Also stamps the local timezone offset so "Send on" delivers correctly. */
    function syncRecipientForm(form) {
      var checkbox = form.querySelector('[data-recipient-checkbox]');
      var fields = form.querySelector('[data-recipient-fields]');
      if (!checkbox || !fields) return;
      var on = checkbox.checked;
      fields.hidden = !on;
      form.querySelectorAll('[data-recipient-input], [data-recipient-offset]').forEach(function (el) {
        el.disabled = !on;
      });
      var offset = form.querySelector('[data-recipient-offset]');
      if (offset && on) offset.value = (new Date().getTimezoneOffset() * -1).toString();
    }
    document.querySelectorAll('[data-recipient-form]').forEach(syncRecipientForm);
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-recipient-checkbox]')) {
        var form = e.target.closest('[data-recipient-form]');
        if (form) syncRecipientForm(form);
      }
    });

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
      if (!btn) return;
      var wrap = btn.closest('.ne-product-buy__qty-wrap');
      if (!wrap) return;
      var input = wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      if (btn.dataset.qtyMinus !== undefined) {
        if (val > 1) input.value = val - 1;
      } else {
        input.value = val + 1;
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* Buy-it-now glow colour: read the wallet button's ACTUAL rendered
       background so the glow can match it (Shopify controls that button's
       colour — not theme-readable in CSS). The payment button is injected
       asynchronously, so retry a handful of times. No-op unless the
       buynow-glow-button (= source "button colour") modifier is present. */
    function syncBuyNowColor() {
      document.querySelectorAll('.ne-product-buy--buynow-glow-button').forEach(function (root) {
        var btn = root.querySelector('.ne-product-buy__dyn-checkout .shopify-payment-button__button');
        if (!btn) return;
        var c = getComputedStyle(btn).backgroundColor;
        if (c && c !== 'rgba(0, 0, 0, 0)' && c !== 'transparent') {
          root.style.setProperty('--ne-buynow-actual-c', c);
        }
      });
    }
    var _bnTimer = null;
    var _bnObserved = false;
    function startBuyNowSync() {
      if (_bnTimer) clearInterval(_bnTimer);
      var tries = 0;
      _bnTimer = setInterval(function () {
        syncBuyNowColor();
        if (++tries >= 12) { clearInterval(_bnTimer); _bnTimer = null; }
      }, 200);
      /* Observe the dyn-checkout containers so the colour is read the INSTANT
         Shopify injects the wallet button — eliminates the polling lag where
         the glow appeared noticeably late (user 2026-05-24). */
      if (window.MutationObserver && !_bnObserved) {
        document.querySelectorAll('.ne-product-buy__dyn-checkout').forEach(function (container) {
          new MutationObserver(syncBuyNowColor).observe(container, { childList: true, subtree: true });
        });
        _bnObserved = true;
      }
    }
    startBuyNowSync();
    /* Restart the retry on customizer section reload / block re-select so a
       freshly-toggled "button colour" source picks up the wallet colour. */
    document.addEventListener('shopify:section:load', function () { _bnObserved = false; startBuyNowSync(); });
    document.addEventListener('shopify:block:select', startBuyNowSync);

    /* ── Express-Bereich erst zeigen, wenn er STEHT ───────────────────────────
       Gegenstueck zur CSS-Regel oben. Shopifys Skelett liegt in einem
       geschlossenen Shadow-Root, ist also von aussen weder les- noch
       gestaltbar — messbar ist nur, ob der Bereich schon eine plausible Hoehe
       hat. Genau daran haengt die Freigabe:
         · hoeher als die halbe reservierte Hoehe  → `is-ready`, Inhalt sichtbar
         · nach 6 s immer noch flach               → `is-empty`, Hoehe faellt weg
       ResizeObserver statt Polling, damit im Ruhezustand nichts laeuft; der
       Zeitgeber ist nur die Reissleine. */
    function expressFreigabe(root) {
      if (!root || root.dataset.neExpressWatch) return;
      root.dataset.neExpressWatch = '1';
      var host = root.querySelector('shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
      var startHoehe = host ? Math.round(host.getBoundingClientRect().height) : 0;
      var ro = null, reissleine = null;
      var fertig = function (klasse) {
        if (root.classList.contains('is-ready') || root.classList.contains('is-empty')) return;
        root.classList.add(klasse);
        if (ro) ro.disconnect();
        clearTimeout(reissleine);
      };
      var pruefe = function () {
        if (!root.firstElementChild) return;               /* noch gar nichts da */
        /* (1) Schneller Weg: ein Knopf im normalen DOM — das ist Shopifys
           "Jetzt kaufen", der sofort fertig gerendert ist (auf Pulse ab 150 ms). */
        var btn = root.querySelector('.shopify-payment-button__button');
        if (btn && btn.getBoundingClientRect().height > 4) return fertig('is-ready');
        /* (2) Wallet-Weg: die Knoepfe liegen in einem geschlossenen Shadow-Root,
           von aussen ist nur die Hoehe des Wirts messbar. Beim Wechsel vom
           Skelett auf die echten Knoepfe aendert sie sich — das ist das Signal. */
        if (host) {
          var jetzt = Math.round(host.getBoundingClientRect().height);
          if (startHoehe > 0 && Math.abs(jetzt - startHoehe) > 3) return fertig('is-ready');
        }
      };
      /* Reissleine: nach 6 s zeigen wir, was da ist — lieber Shopifys Skelett
         als ein dauerhaft leerer Kasten. Ist ueberhaupt kein Kind vorhanden
         (kein Anbieter konfiguriert), faellt die reservierte Hoehe weg. */
      reissleine = setTimeout(function () { fertig(root.firstElementChild ? 'is-ready' : 'is-empty'); }, 6000);
      if (window.ResizeObserver && host) { ro = new ResizeObserver(pruefe); ro.observe(host); }
      pruefe();
      setTimeout(pruefe, 400);
      setTimeout(pruefe, 1500);
      setTimeout(pruefe, 3000);
    }
    function expressStart() {
      document.querySelectorAll('.ne-product-buy__dyn-checkout').forEach(expressFreigabe);
    }
    expressStart();
    document.addEventListener('shopify:section:load', expressStart);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    (function() {
    /* Show-more toggle */
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-product-description-toggle]');
      if (!btn) return;
      var wrap = btn.closest('[data-product-description-truncate]');
      if (!wrap) return;
      var open = wrap.getAttribute('data-expanded') === '1';
      wrap.setAttribute('data-expanded', open ? '0' : '1');
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });

    /* Scroll-mode chevron hint — fades the chevron + bottom mask once
       the user has scrolled the description body to its end. */
    function bindScrollHint(wrap) {
      var body = wrap.querySelector('.ne-product-description__body');
      if (!body || body._neHintBound) return;
      body._neHintBound = true;
      function update() {
        var atBottom = body.scrollTop + body.clientHeight >= body.scrollHeight - 2;
        wrap.setAttribute('data-scroll-bottom', atBottom ? '1' : '0');
      }
      body.addEventListener('scroll', update, { passive: true });
      update();
    }
    function bindAll(scope) {
      (scope || document).querySelectorAll('.ne-product-description--scroll').forEach(bindScrollHint);
    }
    bindAll();
    document.addEventListener('shopify:section:load', function(e) { bindAll(e.target); });
    document.addEventListener('shopify:block:select', function(e) { bindAll(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-grid"] && !Shopify.designMode) return;
  try {
    (function () {
    // Firefox/Gecko (incl. Zen, LibreWolf, Waterfox) can't render
    // backdrop-filter on transformed elements → flag it so coverflow glass
    // falls back to mock-glass. UA contains "Firefox" for all Gecko forks.
    try {
      if (/firefox/i.test(navigator.userAgent)) document.documentElement.classList.add('ne-ff');
    } catch (e) {}
    function initCarousels(root) {
      (root || document).querySelectorAll('.ne-pg__carousel[data-carousel]').forEach(function (carousel) {
        if (carousel.__pgInit) return;
        carousel.__pgInit = true;
        var track = carousel.querySelector('.ne-pg__track');
        var prevBtn = carousel.querySelector('[data-carousel-prev]');
        var nextBtn = carousel.querySelector('[data-carousel-next]');
        if (!track) return;
        function slideWidth() {
          var slide = track.querySelector('.ne-pg__slide');
          if (!slide) return 300;
          return slide.offsetWidth + parseInt(getComputedStyle(track).gap || '16', 10);
        }
        // scrollTo (not scrollBy) per Rule 141 — rapid clicks during a
        // running smooth-scroll: scrollBy gets dropped by the browser.
        if (prevBtn) prevBtn.addEventListener('click', function () {
          track.scrollTo({ left: track.scrollLeft - slideWidth(), behavior: 'smooth' });
        });
        if (nextBtn) nextBtn.addEventListener('click', function () {
          track.scrollTo({ left: track.scrollLeft + slideWidth(), behavior: 'smooth' });
        });
        // Hide off-screen slides so their box-shadow doesn't leak into
        // the visible track area. visibility:hidden hides the element AND
        // its shadow without affecting layout/scroll metrics.
        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              entry.target.style.visibility = entry.isIntersecting ? 'visible' : 'hidden';
            });
          }, { root: track, threshold: 0.01 });
          track.querySelectorAll('.ne-pg__slide').forEach(function (slide) {
            observer.observe(slide);
          });
        }
      });
    }
    function initCoverflows(root) {
      (root || document).querySelectorAll('.ne-pg__coverflow[data-pg-coverflow]').forEach(function (cf) {
        if (cf.__pgCf) return;
        cf.__pgCf = true;
        var cards = Array.prototype.slice.call(cf.querySelectorAll('[data-cf-card]'));
        if (!cards.length) return;
        var n = cards.length;
        var loop = cf.getAttribute('data-cf-loop') === '1';
        var isDrum = cf.classList.contains('ne-pg__coverflow--style-drum');
        var mqMobile = window.matchMedia('(max-width: 749px)');
        var active = 0;
        var cfW = 0; // cached block width for analytic focus migration
        // No-loop focus migration (desktop stack/fan only): the focus card glides
        // from left-of-centre → centre → right-of-centre as you page, so the
        // lopsided pile always fills the block. Loop is symmetric → skipped.
        function focusShift() {
          if (loop || isDrum || mqMobile.matches || !cfW || n < 2) return null;
          var t = active / (n - 1);
          return ((t - 0.5) * 0.42 * cfW).toFixed(0) + 'px';
        }
        function measure() {
          var maxH = 0;
          cards.forEach(function (c) { var h = c.offsetHeight; if (h > maxH) maxH = h; });
          if (maxH) cf.style.setProperty('--ne-cf-h', maxH + 'px');
        }
        // Drum optic: keep the whole composition (focus card + drum ring) centred
        // in the coverflow, like the tuner — measure the visible cards' bounding
        // box and shift them so its centre lands on the coverflow centre.
        function bbox() {
          var minX = Infinity, maxX = -Infinity, any = false;
          cards.forEach(function (c) {
            if (c.hasAttribute('data-hidden')) return;
            var r = c.getBoundingClientRect();
            if (r.width) { any = true; if (r.left < minX) minX = r.left; if (r.right > maxX) maxX = r.right; }
          });
          return any ? { min: minX, max: maxX } : null;
        }
        function recenterDrum() {
          // Transitions off + absolute (not accumulative) so it can't diverge or
          // read a mid-animation frame. 1) zero shift & scale, measure the natural
          // composition; 2) if wider than the coverflow, scale it down to fit;
          // 3) re-measure the scaled box and shift it to the centre.
          cf.classList.add('ne-pg--no-trans');
          cf.style.setProperty('--ne-cf-drum-shift', '0px');
          cf.style.setProperty('--ne-cf-drum-fit', '1');
          cf.style.setProperty('--ne-cf-ring-shift', '0px');
          void cf.offsetWidth;
          var sr = cf.getBoundingClientRect();
          cfW = sr.width;
          var b = bbox();
          var isMob = mqMobile.matches;
          if (b) {
            var fit;
            if (isMob) {
              // Mobile: never shrink-to-fit — keep cards at the tuned full size so
              // the focus card reads big; spill is centred (drum) / clipped at the
              // viewport (guard in critical.css). Drum stays exactly at fit 1 so
              // it matches the mobile-drum tuner geometry.
              fit = isDrum ? 1 : ((b.max - b.min) > sr.width * 1.6 ? (sr.width * 1.6 / (b.max - b.min)) : 1);
            } else {
              var avail = sr.width * 0.96;
              fit = (b.max - b.min) > avail ? (avail / (b.max - b.min)) : 1;
            }
            cf.style.setProperty('--ne-cf-drum-fit', fit.toFixed(3));
            void cf.offsetWidth;
            if (isMob) {
              // Always centre the FOCUS card on mobile (drum: above the ring;
              // stack/fan: focus dominant, neighbours as edge slivers).
              var fc = cards[active] ? cards[active].getBoundingClientRect() : null;
              if (fc) cf.style.setProperty('--ne-cf-drum-shift', ((sr.left + sr.width / 2) - (fc.left + fc.right) / 2).toFixed(0) + 'px');
              // Mobile drum: the ring (non-focus cards) is a one-directional fan,
              // so its bbox isn't centred under the focus — shift the ring (only)
              // back to centre via --ne-cf-ring-shift. Literal px (applied after
              // scale in the transform), uniform → one pass suffices.
              if (isDrum) {
                void cf.offsetWidth;
                var rmin = Infinity, rmax = -Infinity;
                cards.forEach(function (c, i) {
                  if (i === active || c.hasAttribute('data-hidden')) return;
                  var cr = c.getBoundingClientRect();
                  if (cr.width) { if (cr.left < rmin) rmin = cr.left; if (cr.right > rmax) rmax = cr.right; }
                });
                // Centre the ring's bbox + a small extra LEFT nudge (the rotateY
                // fan reads visually right-heavy, so its bbox-centre sits a touch
                // right of where it looks centred). Nudge is a fraction of the
                // coverflow width so it holds across phone sizes (tuner: 2026-06-26).
                if (rmin < Infinity) {
                  var ringNudge = sr.width * 0;
                  cf.style.setProperty('--ne-cf-ring-shift', (((sr.left + sr.width / 2) - (rmin + rmax) / 2) + ringNudge).toFixed(0) + 'px');
                }
              }
            } else if (!loop && !isDrum) {
              // No loop, stack/fan: migrate the focus card instead of centring the (lopsided) bbox.
              cf.style.setProperty('--ne-cf-drum-shift', focusShift() || '0px');
            } else {
              var b2 = bbox();
              if (b2) {
                // Centre the whole composition (focus card + ring) in the block.
                var sh2 = (sr.left + sr.width / 2) - (b2.min + b2.max) / 2;
                cf.style.setProperty('--ne-cf-drum-shift', sh2.toFixed(0) + 'px');
              }
            }
          }
          void cf.offsetWidth;
          cf.classList.remove('ne-pg--no-trans');
          // Drum: left arrow goes in the gap between the focus card and the drum
          // ring, the right arrow just past the ring — not the empty coverflow
          // margins.
          if (isDrum && !mqMobile.matches) {
            var b3 = bbox();
            var pa = cf.querySelector('[data-cf-prev]'), na = cf.querySelector('[data-cf-next]');
            var fr = cards[active] ? cards[active].getBoundingClientRect() : null;
            var ringLeft = Infinity;
            cards.forEach(function (c, i) {
              if (i === active || c.hasAttribute('data-hidden')) return;
              var cr = c.getBoundingClientRect();
              if (cr.width && cr.left < ringLeft) ringLeft = cr.left;
            });
            // Vertical: lock both chevrons onto the focus card's centre (the +30px
            // box padding / scale would otherwise leave them a touch off-centre).
            if (fr) {
              var cy = (fr.top + fr.bottom) / 2 - sr.top;
              if (pa) pa.style.top = cy + 'px';
              if (na) na.style.top = cy + 'px';
            }
            // Horizontal: left chevron hugs the drum — its centre sits on the
            // ring's front-left edge (overlapping a touch), not floating out in
            // the gap toward the focus card.
            if (pa && ringLeft < Infinity) {
              pa.style.left = (ringLeft - sr.left - pa.offsetWidth * 0.5 + 2) + 'px';
            }
            if (b3 && na) na.style.right = Math.max(2, sr.right - b3.max - na.offsetWidth - 6) + 'px';
          } else if (isDrum) {
            // Mobile drum: chevrons sit ON the ring (below the focus), one to the
            // left and one to the right of the ring's extent, at its vertical
            // centre — not on the focus card up top.
            var paM = cf.querySelector('[data-cf-prev]'), naM = cf.querySelector('[data-cf-next]');
            var rmn = Infinity, rmx = -Infinity, rcy = 0, rcn = 0;
            cards.forEach(function (c, i) {
              if (i === active || c.hasAttribute('data-hidden')) return;
              var cr = c.getBoundingClientRect();
              if (cr.width) { if (cr.left < rmn) rmn = cr.left; if (cr.right > rmx) rmx = cr.right; rcy += (cr.top + cr.bottom) / 2; rcn++; }
            });
            if (rcn && paM && naM) {
              var cyR = rcy / rcn - sr.top;
              paM.style.top = cyR + 'px'; naM.style.top = cyR + 'px';
              paM.style.right = ''; naM.style.left = '';
              paM.style.left = Math.max(2, rmn - sr.left - paM.offsetWidth - 4) + 'px';
              naM.style.right = Math.max(2, sr.right - rmx - naM.offsetWidth - 4) + 'px';
            }
          }
        }
        function render() {
          cards.forEach(function (card, idx) {
            var d = idx - active;
            if (loop) { if (d > n / 2) d -= n; else if (d < -n / 2) d += n; }
            var ad = Math.abs(d);
            // Drum index: one-directional sequence from the active card (0 = active,
            // 1 = next … n-1 = previous) so every card lines up around the drum.
            // Loop wraps the ring full; no-loop runs forward-only so the ring
            // empties as you reach the last card (di = forward distance).
            var di = loop ? ((idx - active + n) % n) : d;
            // Visibility: the mobile drum keeps a SHORT CONTIGUOUS ring (di 0..4)
            // so its one-directional fan stays clean + centred (hiding by ad would
            // leave non-contiguous di values and scatter the ring). Mobile stack/
            // fan show only ±2 neighbours. Desktop drum keeps its full ring;
            // desktop stack/fan cap at ±6.
            var hidden;
            if (mqMobile.matches) { hidden = isDrum ? (loop ? di > 4 : (d < 0 || d > 4)) : (ad > 2); }
            else if (isDrum) { hidden = loop ? false : (d < 0); }
            else { hidden = ad > 6; }
            if (hidden) {
              card.setAttribute('data-hidden', '');
              card.removeAttribute('data-active');
              return;
            }
            card.removeAttribute('data-hidden');
            card.style.setProperty('--d', d);
            card.style.setProperty('--ad', ad);
            // Compressed distance (pow < 1): gaps shrink as cards move away from
            // focus, so near cards stay open and far cards overlap more. Used by
            // the fan + drum optics; stack uses the raw --d / --ad.
            var cad = Math.pow(ad, 0.6);
            card.style.setProperty('--cad', cad.toFixed(3));
            card.style.setProperty('--cd', (d < 0 ? -cad : cad).toFixed(3));
            // Geometric distance: visible fraction halves each step out
            // (neighbour ~half shown, next ~quarter…) for a broad fan that
            // overlaps progressively toward the edges.
            var gad = 2 * (1 - Math.pow(0.5, ad));
            card.style.setProperty('--gad', gad.toFixed(3));
            card.style.setProperty('--gd', (d < 0 ? -gad : gad).toFixed(3));
            // --di computed above (before the hide check). --din = di normalised
            // 0..1 (for the end-of-drum fade-out only).
            card.style.setProperty('--di', di);
            card.style.setProperty('--din', (n > 1 ? di / (n - 1) : 0).toFixed(3));
            if (d === 0) { card.setAttribute('data-active', ''); }
            else { card.removeAttribute('data-active'); }
          });
          var fs = focusShift();
          if (fs !== null) cf.style.setProperty('--ne-cf-drum-shift', fs);
        }
        function go(t) {
          if (loop) { active = (t % n + n) % n; }
          else { active = Math.max(0, Math.min(n - 1, t)); }
          render();
        }
        var nextBtn = cf.querySelector('[data-cf-next]');
        var prevBtn = cf.querySelector('[data-cf-prev]');
        if (nextBtn) nextBtn.addEventListener('click', function () { go(active + 1); });
        if (prevBtn) prevBtn.addEventListener('click', function () { go(active - 1); });
        // Click a side card to bring it into focus (links/buttons still work).
        cards.forEach(function (card, idx) {
          card.addEventListener('click', function (e) {
            // A click on any non-focus card brings it into focus instead of
            // opening the product; only the focus card's links/buttons navigate.
            if (idx !== active) {
              e.preventDefault();
              e.stopPropagation();
              go(idx);
            }
          });
        });
        // ---- Paging gestures (coverflow_nav) -------------------------------
        var nav = cf.getAttribute('data-cf-nav') || 'arrows';
        // Mobile standard for every optic: swipe/drag + the always-present tap
        // chevrons. Hover-edge has no touch, scroll fights the page, arrows are
        // tap-only — so on phones drag is the one gesture that always feels right.
        if (mqMobile.matches) {
          nav = 'drag';
          cf.classList.add('ne-pg__coverflow--nav-drag');
        }
        if (nav === 'hover-edge') {
          // Cursor near an edge pages continuously; closer to the edge = faster.
          var hDir = 0, hProx = 0, hRaf = null, hLast = 0;
          var hLoop = function (t) {
            if (hDir === 0) { hRaf = null; return; }
            var interval;
            if (isDrum) {
              // Gentler than the symmetric optics; the backward (left) direction is
              // gentler still so it never feels twitchy near the focus card.
              interval = 780 - hProx * (hDir < 0 ? 250 : 360);
            } else {
              interval = 720 - hProx * 540;
            }
            if (t - hLast >= interval) { go(active + hDir); hLast = t; }
            hRaf = requestAnimationFrame(hLoop);
          };
          // Drum hover zones as fractions of the section width (dialled in via the
          // drum-trigger tuner, 2026-06-26): [0..DEAD_END] = focus card, dead so it
          // can be looked at; [DEAD_END..SPLIT] = back; [SPLIT..FWD_END] = forward;
          // [FWD_END..1] = empty right margin, dead (so forward isn't span-heavy).
          var DZ_DEAD_END = 0.38, DZ_SPLIT = 0.59, DZ_FWD_END = 0.79;
          cf.addEventListener('pointermove', function (e) {
            // Hover-edge is cursor semantics — ignore touch (no hover); on phones
            // finger-hold would page continuously + fight the page scroll. Mobile
            // pages via the always-present tap chevrons instead.
            if (e.pointerType === 'touch') { hDir = 0; return; }
            var r = cf.getBoundingClientRect();
            if (isDrum) {
              // Fraction-based zones: focus card dead, then back + forward bands,
              // empty right margin dead. Prox ramps from the split (slow) outward.
              var xf = (e.clientX - r.left) / Math.max(1, r.width);
              if (xf < DZ_DEAD_END || xf > DZ_FWD_END) { hDir = 0; }
              else if (xf < DZ_SPLIT) { hDir = -1; hProx = Math.min(1, (DZ_SPLIT - xf) / Math.max(0.01, DZ_SPLIT - DZ_DEAD_END)); }
              else { hDir = 1; hProx = Math.min(1, (xf - DZ_SPLIT) / Math.max(0.01, DZ_FWD_END - DZ_SPLIT)); }
            } else {
              var x = (e.clientX - r.left) / r.width, z = 0.22;
              if (x < z) { hDir = -1; hProx = (z - x) / z; }
              else if (x > 1 - z) { hDir = 1; hProx = (x - (1 - z)) / z; }
              else { hDir = 0; }
            }
            if (hDir !== 0 && !hRaf) { hLast = 0; hRaf = requestAnimationFrame(hLoop); }
          });
          cf.addEventListener('pointerleave', function () { hDir = 0; });
        } else if (nav === 'drag') {
          // Drag (mouse/touch) pages live, snapping to the nearest card.
          var dDrag = false, dStartX = 0, dStartActive = 0, dSteps = 0, dMoved = 0, dStep = 60;
          cf.addEventListener('pointerdown', function (e) {
            // Start anywhere — including on a card/link; a real drag is suppressed
            // below so it doesn't open a product, while a tap still works.
            dDrag = true; dStartX = e.clientX; dStartActive = active; dSteps = 0; dMoved = 0;
            dStep = Math.max(54, cf.getBoundingClientRect().width * 0.11);
            try { cf.setPointerCapture(e.pointerId); } catch (err) {}
            cf.classList.add('ne-pg__coverflow--grabbing');
          });
          cf.addEventListener('pointermove', function (e) {
            if (!dDrag) return;
            var dx = e.clientX - dStartX; dMoved = Math.abs(dx);
            var steps = Math.round(-dx / dStep);
            if (steps !== dSteps) { dSteps = steps; go(dStartActive + steps); }
          });
          var dEnd = function () { if (dDrag) { dDrag = false; cf.classList.remove('ne-pg__coverflow--grabbing'); } };
          cf.addEventListener('pointerup', dEnd);
          cf.addEventListener('pointercancel', dEnd);
          // Suppress the click that ends a real drag so it doesn't open a product.
          cf.addEventListener('click', function (e) { if (dMoved > 6) { e.preventDefault(); e.stopPropagation(); dMoved = 0; } }, true);
          // Block the browser's native image/link drag so grabbing a card drags.
          cf.addEventListener('dragstart', function (e) { e.preventDefault(); });
        } else if (nav === 'scroll') {
          // Wheel / trackpad over the coverflow pages one card at a time.
          var sAcc = 0, sLock = false;
          cf.addEventListener('wheel', function (e) {
            var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
            sAcc += d; e.preventDefault();
            if (sLock) return;
            if (Math.abs(sAcc) >= 48) {
              go(active + (sAcc > 0 ? 1 : -1)); sAcc = 0; sLock = true;
              setTimeout(function () { sLock = false; }, 200);
            }
          }, { passive: false });
        }
        measure();
        render();
        // Fit + centre the whole composition for every coverflow optic.
        recenterDrum(); requestAnimationFrame(recenterDrum); setTimeout(recenterDrum, 450);
        // Re-measure after images load (Customizer / lazy images report 0 first).
        cf.querySelectorAll('img').forEach(function (img) {
          if (!img.complete) img.addEventListener('load', function () { measure(); recenterDrum(); }, { once: true });
        });
        requestAnimationFrame(measure);
        setTimeout(measure, 400);
        requestAnimationFrame(recenterDrum); setTimeout(recenterDrum, 500);
        window.addEventListener('resize', function () { measure(); render(); recenterDrum(); });
        if (window.ResizeObserver) { new ResizeObserver(measure).observe(cf); }
      });
    }
    document.addEventListener('DOMContentLoaded', function () { initCarousels(document); initCoverflows(document); });
    // Re-init after customizer re-renders the section/block.
    document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); initCoverflows(e.target); });
    document.addEventListener('shopify:block:select', function (e) { initCarousels(e.target.parentElement || document); initCoverflows(e.target.parentElement || document); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-pickup"] && !Shopify.designMode) return;
  try {
    /* Toggle the store list open/closed. Delegated so it survives the
     AJAX content swap on variant change. */
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pickup-toggle]');
      if (!btn) return;
      var root = btn.closest('[data-pickup-availability]');
      if (!root) return;
      var list = root.querySelector('[data-pickup-list]');
      if (!list) return;
      var open = !list.hasAttribute('hidden');
      if (open) { list.setAttribute('hidden', ''); } else { list.removeAttribute('hidden'); }
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-selling-plan"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('change', function(e) {
      var input = e.target;
      if (!input.matches('[data-selling-plan-input]')) return;
      var group = input.closest('[data-selling-plan]');
      if (!group) return;
      group.querySelectorAll('.ne-product-selling-plan__option').forEach(function(opt) {
        var i = opt.querySelector('[data-selling-plan-input]');
        opt.classList.toggle('ne-product-selling-plan__option--active', i && i.checked);
      });
      /* Sync to product form (the buy-buttons block's hidden form). The form
         doesn't have selling_plan input by default — inject one. */
      var form = document.querySelector('[data-product-section] form[action*="/cart/add"]');
      if (!form) return;
      var existing = form.querySelector('input[name="selling_plan"]');
      if (existing) {
        existing.value = input.value;
      } else {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'selling_plan';
        hidden.value = input.value;
        form.appendChild(hidden);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-share"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-product-share]');
      if (!btn) return;
      var url = window.location.href;
      var title = document.title;
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function() {});
        return;
      }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function() {
          btn.dataset.copied = '1';
          setTimeout(function() { delete btn.dataset.copied; }, 1500);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-size-chart"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('click', function(e) {
      var openBtn = e.target.closest('[data-size-chart-open]');
      if (openBtn) {
        var id = openBtn.getAttribute('data-size-chart-open');
        var modal = document.getElementById('size-chart-' + id);
        if (modal && typeof modal.showModal === 'function') modal.showModal();
        return;
      }
      var closeBtn = e.target.closest('[data-size-chart-close]');
      if (closeBtn) {
        var modal = closeBtn.closest('[data-size-chart-modal]');
        if (modal && modal.open) modal.close();
        return;
      }
    });
    /* Backdrop click closes (target is the dialog itself when clicked outside content) */
    document.addEventListener('click', function(e) {
      if (e.target.matches('[data-size-chart-modal]') && e.target.open) e.target.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-tab-target]');
      if (!btn) return;
      var tabs = btn.closest('[data-product-tabs]');
      if (!tabs) return;
      var idx = btn.getAttribute('data-tab-target');
      tabs.querySelectorAll('[data-tab-target]').forEach(function(b) {
        var match = b.getAttribute('data-tab-target') === idx;
        b.classList.toggle('ne-product-tabs__btn--active', match);
        b.setAttribute('aria-selected', match ? 'true' : 'false');
      });
      tabs.querySelectorAll('[data-tab-panel]').forEach(function(p) {
        var match = p.getAttribute('data-tab-panel') === idx;
        p.hidden = !match;
        p.classList.toggle('ne-product-tabs__panel--active', match);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["recently-viewed-grid"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'ne-recently-viewed';
    var MAX_STORED = 24;

    function trackCurrent(handle) {
      if (!handle) return;
      var raw;
      try { raw = localStorage.getItem(STORAGE_KEY); } catch (_) { return; }
      var list = [];
      try { list = JSON.parse(raw || '[]'); if (!Array.isArray(list)) list = []; } catch (_) { list = []; }
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      if (list.length > MAX_STORED) list = list.slice(0, MAX_STORED);
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (_) {}
    }

    function readList() {
      var raw;
      try { raw = localStorage.getItem(STORAGE_KEY); } catch (_) { return []; }
      try {
        var list = JSON.parse(raw || '[]');
        return Array.isArray(list) ? list : [];
      } catch (_) { return []; }
    }

    function formatMoney(cents) {
      try {
        if (window.Shopify && Shopify.formatMoney) {
          // Format string comes from window.Shopify.money_format or the grid's
          // data-money-format (rendered from shop.money_format). Reading it at
          // runtime keeps Liquid out of this javascript block (the old inline
          // money-format literal tripped StaticStylesheetAndJavascriptTags).
          var fmt = window.Shopify.money_format;
          if (!fmt) {
            var el = document.querySelector('[data-rv-grid][data-money-format]');
            if (el) { fmt = el.getAttribute('data-money-format'); }
          }
          if (fmt) { return Shopify.formatMoney(cents, fmt); }
        }
      } catch (_) {}
      return '$' + (Math.round(cents) / 100).toFixed(2);
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function thumbUrl(src, width) {
      if (!src) return '';
      try {
        return src.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_' + width + 'x$1$2');
      } catch (_) { return src; }
    }

    function renderCard(p, opts) {
      var primary = p.featured_image ? thumbUrl(p.featured_image, 600) : '';
      var secondary = '';
      if (opts.showSecondary && p.images && p.images.length > 1) {
        /* Pick the first non-featured image. p.images entries can be
           string URLs or {src} objects depending on shop config. */
        for (var i = 0; i < p.images.length; i++) {
          var src = typeof p.images[i] === 'string' ? p.images[i] : (p.images[i] && p.images[i].src);
          if (src && src !== p.featured_image) {
            secondary = thumbUrl(src, 600);
            break;
          }
        }
      }

      var imgHtml = primary
        ? '<img class="ne-rv-card__img--primary" src="' + escapeHtml(primary) + '" alt="' + escapeHtml(p.title || '') + '" loading="lazy" decoding="async">'
        : '';
      var secondaryHtml = secondary
        ? '<img class="ne-rv-card__img--secondary" src="' + escapeHtml(secondary) + '" alt="" loading="lazy" decoding="async" aria-hidden="true">'
        : '';

      var onSale = p.compare_at_price && p.compare_at_price > p.price;
      var soldOut = p.available === false;
      /* "New" eligibility — settings.badge_show_new + within N days. */
      var isNew = false;
      if (opts.showNew && p.created_at) {
        var ageMs = Date.now() - new Date(p.created_at).getTime();
        if (ageMs <= opts.newDays * 86400 * 1000) isNew = true;
      }
      var badge = '';
      if (soldOut) {
        badge = '<span class="ne-rv-card__badge-pos ne-badge ne-badge--card ne-badge--sold-out">' + escapeHtml(opts.labelSoldOut) + '</span>';
      } else {
        var parts = [];
        if (onSale) {
          var saleLabel;
          if (opts.badgeFormat === 'text') {
            saleLabel = opts.labelSale;
          } else if (opts.badgeFormat === 'absolute') {
            saleLabel = '-' + escapeHtml(formatMoney(p.compare_at_price - p.price));
          } else {
            var savings = Math.round((p.compare_at_price - p.price) / p.compare_at_price * 100);
            saleLabel = '-' + savings + '%';
          }
          parts.push('<span class="ne-badge ne-badge--card ne-badge--sale">' + escapeHtml(saleLabel) + '</span>');
        }
        if (isNew) {
          var showNew = !(onSale && !opts.showBoth);
          if (showNew) parts.push('<span class="ne-badge ne-badge--card ne-badge--new">' + escapeHtml(opts.labelNew) + '</span>');
        }
        if (parts.length) {
          badge = '<span class="ne-rv-card__badge-pos">' + parts.join('') + '</span>';
        }
      }

      var vendorHtml = '';
      if (opts.showVendor && p.vendor) {
        vendorHtml = '<p class="ne-rv-card__vendor">' + escapeHtml(p.vendor) + '</p>';
      }

      var compareHtml = '';
      if (opts.showCompare && onSale) {
        compareHtml = '<span class="ne-rv-card__compare">' + escapeHtml(formatMoney(p.compare_at_price)) + '</span>';
      }
      var priceCls = 'ne-rv-card__price' + (onSale ? ' ne-rv-card__price--sale' : '');

      var cardCls = 'ne-rv-card' + (secondary ? ' ne-rv-card--has-secondary' : '');


      return ''
        + '<div class="' + cardCls + '">'
        +   '<a class="ne-rv-card__link" href="/products/' + escapeHtml(p.handle) + '">'
        +     '<div class="ne-rv-card__media">' + badge + imgHtml + secondaryHtml + '</div>'
        +     vendorHtml
        +     '<h3 class="ne-rv-card__title">' + escapeHtml(p.title) + '</h3>'
        +     '<div class="' + priceCls + '">'
        +       '<span>' + escapeHtml(formatMoney(p.price)) + '</span>'
        +       compareHtml
        +     '</div>'
        +   '</a>'
        + '</div>';
    }

    function initGrid(el) {
      if (el.__rvInit) return;
      el.__rvInit = true;

      var limit = parseInt(el.getAttribute('data-limit'), 10) || 4;
      var current = el.getAttribute('data-current-product') || '';
      var excludeCurrent = el.getAttribute('data-exclude-current') === '1';
      var showCompare = el.getAttribute('data-show-compare') === '1';
      var showVendor = el.getAttribute('data-show-vendor') === '1';
      var showSecondary = el.getAttribute('data-show-secondary') === '1';
      var badgeFormat = el.getAttribute('data-badge-format') || 'percent';
      var showNew = el.getAttribute('data-show-new') === '1';
      var labelSoldOut = el.getAttribute('data-i18n-sold-out') || 'Sold out';
      var labelNew = el.getAttribute('data-i18n-new') || 'New';
      var labelSale = el.getAttribute('data-i18n-sale') || 'Sale';
      var newDays = parseInt(el.getAttribute('data-new-days'), 10) || 14;
      var showBoth = el.getAttribute('data-show-both') === '1';
      var isCf = el.classList.contains('ne-cf');
      var cfCardCls = el.getAttribute('data-cf-card-cls') || 'ne-cf__card';
      var cfCardRadius = el.getAttribute('data-cf-card-radius') || '';
      var track = isCf ? el.querySelector('[data-cf-stage]') : el.querySelector('[data-rv-track]');
      var emptyEl = el.querySelector('[data-rv-empty]');
      if (!track) return;

      /* Track current product page in storage. */
      if (current) trackCurrent(current);

      var handles = readList();
      if (excludeCurrent && current) {
        handles = handles.filter(function (h) { return h !== current; });
      }
      handles = handles.slice(0, limit);

      if (handles.length === 0) {
        el.setAttribute('data-rv-state', 'empty');
        if (emptyEl) emptyEl.hidden = false;
        return;
      }

      Promise.all(handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (products) {
        var valid = products.filter(Boolean);
        if (valid.length === 0) {
          el.setAttribute('data-rv-state', 'empty');
          if (emptyEl) emptyEl.hidden = false;
          return;
        }
        track.innerHTML = valid.map(function (p) {
          var card = renderCard(p, {
            showCompare: showCompare,
            showVendor: showVendor,
            showSecondary: showSecondary,
            badgeFormat: badgeFormat,
            showNew: showNew,
            newDays: newDays,
            showBoth: showBoth,
            labelSoldOut: labelSoldOut,
            labelNew: labelNew,
            labelSale: labelSale,
          });
          if (isCf) {
            var styleAttr = cfCardRadius ? ' style="--ne-cf-card-radius:' + cfCardRadius + 'px"' : '';
            return '<div class="' + cfCardCls + '" data-cf-card' + styleAttr + '>' + card + '</div>';
          }
          return card;
        }).join('');
        el.setAttribute('data-rv-state', 'loaded');
        if (isCf && window.neInitCoverflows) {
          /* Cards are built async after the DOMContentLoaded scan already
             claimed this empty .ne-cf (sets __neCf=true on first pass). Reset the
             guard so the now-populated stage initialises. (Rule: idempotent re-init.) */
          el.__neCf = false;
          window.neInitCoverflows(el.parentElement || document);
        }
      });
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-rv-grid]').forEach(initGrid);
    }

    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    document.addEventListener('shopify:section:load',  function (e) { initAll(e.target); });
    document.addEventListener('shopify:block:select',  function (e) { initAll(e.target.parentElement || document); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shape"] && !Shopify.designMode) return;
  try {
    (function () {
    var SVGNS = 'http://www.w3.org/2000/svg';

    // Each point is [x, y, r] where r is the per-corner radius (-1 = use the
    // shape's general radius). Only freeform corners can carry a custom radius.
    function points(el) {
      var pts = [];
      if (el.hasAttribute('data-shape-freeform')) {
        var nodes = el.querySelectorAll('.ne-shape__pt');
        for (var i = 0; i < nodes.length; i++) {
          var x = parseFloat(nodes[i].getAttribute('data-x'));
          var y = parseFloat(nodes[i].getAttribute('data-y'));
          var r = parseFloat(nodes[i].getAttribute('data-r'));
          pts.push([isNaN(x) ? 50 : x, isNaN(y) ? 50 : y, isNaN(r) ? -1 : r]);
        }
      } else {
        var raw = (el.getAttribute('data-shape-points') || '').trim();
        if (raw) {
          raw.split(/\s+/).forEach(function (s) {
            var a = s.split(',');
            var px = parseFloat(a[0]), py = parseFloat(a[1]);
            if (!isNaN(px) && !isNaN(py)) pts.push([px, py, -1]);
          });
        }
      }
      if (pts.length < 3) pts = [[50, 0, -1], [100, 100, -1], [0, 100, -1]];
      return pts;
    }

    // Rounded polygon as an objectBoundingBox path (0–1 coords). A fixed px
    // radius is converted to per-edge offsets using the element's pixel size,
    // so the fillet looks uniform regardless of aspect ratio.
    function roundedPath(pts, w, h, globalR) {
      var n = pts.length, f = pts.map(function (p) { return [p[0] / 100, p[1] / 100, p[2]]; });
      function lenPx(a, b) { return Math.hypot((b[0] - a[0]) * w, (b[1] - a[1]) * h) || 1e-6; }
      var d = '';
      for (var i = 0; i < n; i++) {
        var V = f[i], P = f[(i - 1 + n) % n], N = f[(i + 1) % n];
        var Rv = (V[2] >= 0) ? V[2] : globalR;       // per-corner radius overrides the general one
        var l1 = lenPx(V, P), l2 = lenPx(V, N);
        var t = Math.min(Rv, l1 / 2, l2 / 2);
        if (t <= 0) {
          d += (i === 0 ? 'M' : ' L') + V[0].toFixed(4) + ',' + V[1].toFixed(4);  // sharp vertex
          continue;
        }
        var A = [V[0] + (P[0] - V[0]) * (t / l1), V[1] + (P[1] - V[1]) * (t / l1)];
        var B = [V[0] + (N[0] - V[0]) * (t / l2), V[1] + (N[1] - V[1]) * (t / l2)];
        d += (i === 0 ? 'M' : ' L') + A[0].toFixed(4) + ',' + A[1].toFixed(4);
        d += ' Q' + V[0].toFixed(4) + ',' + V[1].toFixed(4) + ' ' + B[0].toFixed(4) + ',' + B[1].toFixed(4);
      }
      return d + ' Z';
    }

    function aspectOf(el) {
      var a = getComputedStyle(el).aspectRatio || '';
      var m = a.split('/');
      var rw = parseFloat(m[0]), rh = parseFloat(m[1]);
      if (rw > 0 && rh > 0) return rw / rh;
      return 1;
    }

    function applyRound(el, pts) {
      var fill = el.querySelector('.ne-shape__fill');
      if (!fill) return;
      var r = el.getBoundingClientRect();
      // Use measured pixels when laid out; otherwise derive a ratio-correct
      // nominal box from aspect-ratio so the fillet never squishes and the clip
      // is set even before/without layout (a hug-width parent can be 0 here).
      var w, h;
      if (r.width >= 2 && r.height >= 2) { w = r.width; h = r.height; }
      else { w = 320; h = 320 / aspectOf(el); }
      var R = parseFloat(el.getAttribute('data-shape-radius')) || 0;
      var id = 'ne-clip-' + (el.getAttribute('data-shape-id') || Math.round(w * h));
      var svg = el.querySelector('svg.ne-shape__clipsvg');
      if (!svg) {
        svg = document.createElementNS(SVGNS, 'svg');
        svg.setAttribute('class', 'ne-shape__clipsvg');
        svg.setAttribute('width', '0'); svg.setAttribute('height', '0');
        var defs = document.createElementNS(SVGNS, 'defs');
        var cp = document.createElementNS(SVGNS, 'clipPath');
        cp.setAttribute('clipPathUnits', 'objectBoundingBox');
        cp.setAttribute('id', id);
        var path = document.createElementNS(SVGNS, 'path');
        cp.appendChild(path); defs.appendChild(cp); svg.appendChild(defs);
        el.appendChild(svg);
      }
      svg.querySelector('path').setAttribute('d', roundedPath(pts, w, h, R));
      fill.style.clipPath = 'url(#' + id + ')';
      fill.style.webkitClipPath = 'url(#' + id + ')';
    }

    var RO = (typeof ResizeObserver !== 'undefined') ? new ResizeObserver(function (entries) {
      entries.forEach(function (e) { applyRound(e.target, points(e.target)); });
    }) : null;

    function build(el) {
      var pts = points(el);
      // Size the image to the polygon's bounding box so it fits the SHAPE
      // (not the block) at 100%; transform translate/scale then moves it freely.
      var img = el.querySelector('.ne-shape__img');
      if (img) {
        var minX = 100, minY = 100, maxX = 0, maxY = 0;
        for (var k = 0; k < pts.length; k++) {
          if (pts[k][0] < minX) minX = pts[k][0];
          if (pts[k][0] > maxX) maxX = pts[k][0];
          if (pts[k][1] < minY) minY = pts[k][1];
          if (pts[k][1] > maxY) maxY = pts[k][1];
        }
        img.style.left = minX + '%';
        img.style.top = minY + '%';
        img.style.width = (maxX - minX) + '%';
        img.style.height = (maxY - minY) + '%';
      }
      var globalR = parseFloat(el.getAttribute('data-shape-radius')) || 0;
      var anyCustom = false;
      for (var c = 0; c < pts.length; c++) { if (pts[c][2] > 0) { anyCustom = true; break; } }
      var rounded = globalR > 0 || anyCustom;
      if (rounded) {
        applyRound(el, pts);
        if (RO && !el._neRO) { RO.observe(el); el._neRO = true; }
      } else {
        el.style.setProperty('--ne-shape-clip',
          'polygon(' + pts.map(function (p) { return p[0] + '% ' + p[1] + '%'; }).join(', ') + ')');
        var fill = el.querySelector('.ne-shape__fill');
        if (fill) { fill.style.removeProperty('clip-path'); fill.style.removeProperty('-webkit-clip-path'); }
      }
      var hd = el.querySelector('.ne-shape__handles');
      if (hd) {
        hd.innerHTML = pts.map(function (p, i) {
          return '<span class="ne-shape__handle" style="left:' + p[0] + '%;top:' + p[1] + '%">' + (i + 1) + '</span>';
        }).join('');
      }
    }

    function run(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var list = root.querySelectorAll('.ne-shape[data-shape-freeform], .ne-shape[data-shape-round="1"], .ne-shape[data-shape-img="1"]');
      for (var i = 0; i < list.length; i++) build(list[i]);
    }

    if (document.readyState !== 'loading') { run(); }
    else { document.addEventListener('DOMContentLoaded', function () { run(); }); }
    document.addEventListener('shopify:section:load', function (e) { run(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      run((e.target && e.target.closest) ? (e.target.closest('.shopify-section') || document) : document);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["testimonial-list"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCarousels(root) {
      (root || document).querySelectorAll('[data-tl-carousel]').forEach(function (c) {
        if (c.__tlInit) return;
        c.__tlInit = true;
        var track = c.querySelector('[data-tl-track]');
        var nav = c.querySelector('[data-tl-nav]');
        var prev = c.querySelector('[data-tl-prev]');
        var next = c.querySelector('[data-tl-next]');
        if (!track) return;

        // Hide off-screen testimonial cards so their box-shadow doesn't
        // leak into the visible track area. visibility:hidden hides the
        // element AND its shadow without affecting layout/scroll metrics.
        if ('IntersectionObserver' in window) {
          var visObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              entry.target.style.visibility = entry.isIntersecting ? 'visible' : 'hidden';
            });
          }, { root: track, threshold: 0.01 });
          track.querySelectorAll('.ne-testimonial').forEach(function (slide) {
            visObserver.observe(slide);
          });
        }

        var loop = c.getAttribute('data-tl-loop') === '1';

        function step() {
          var slide = track.firstElementChild;
          while (slide && slide.classList && slide.classList.contains('shopify-block') && slide.firstElementChild) {
            slide = slide.firstElementChild;
            break;
          }
          var w = slide ? slide.getBoundingClientRect().width : track.clientWidth;
          var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0', 10);
          return w + gap;
        }

        /* Nav visibility — hide arrows when all cards fit (no overflow).
           With loop active arrows stay visible regardless of overflow
           (there's always something to rotate in).
           Re-evaluated on resize because visible columns are responsive. */
        function syncNav() {
          if (!nav) return;
          if (loop && track.children.length > 1) { nav.hidden = false; return; }
          var overflow = track.scrollWidth - track.clientWidth > 2;
          nav.hidden = !overflow;
        }
        syncNav();
        window.addEventListener('resize', syncNav);
        /* Re-measure after images load (avatars may change slide height → scrollWidth). */
        track.querySelectorAll('img').forEach(function (img) {
          if (!img.complete) img.addEventListener('load', syncNav, { once: true });
        });

        var isEditor = !!(window.Shopify && window.Shopify.designMode);
        /* True seamless loop uses DOM rotation. Previously skipped in
           customizer to avoid confusing the block-insertion UI, but
           the visible scrollTo-wrap "jump" is unacceptable in the
           customizer mobile preview. Trade-off accepted: clicking on
           a card in customizer may select the wrong block when DOM
           is rotated, but the seamless visual is more important. */
        var rotateLoop = loop;

        function atStart() { return track.scrollLeft <= 2; }
        function atEnd()   { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; }
        function gapPx()   { return parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0', 10); }


        /* DOM rotation helpers. scroll-snap-type MUST be suspended during
           the scrollLeft reset — otherwise the browser re-snaps to the
           next snap-point mid-swap, producing a visible jitter (stars
           are auto-height subgrid rows → subpixel shifts are perceived
           as shaking). scroll-behavior: auto keeps the reset instant. */
        var isRotating = false;
        function domRotate(direction) {
          if (isRotating) return false;
          var isForward = direction === 'forward';
          var node = isForward ? track.firstElementChild : track.lastElementChild;
          if (!node) return false;
          if (direction !== 'eager-backward') {
            var tRect = track.getBoundingClientRect();
            var nRect = node.getBoundingClientRect();
            var offScreen = isForward
              ? nRect.right <= tRect.left + 1
              : nRect.left  >= tRect.right - 1;
            if (!offScreen) return false;
          }
          var w = node.offsetWidth + gapPx();
          isRotating = true;
          var prevBehavior = track.style.scrollBehavior;
          var prevSnap = track.style.scrollSnapType;
          track.style.scrollBehavior = 'auto';
          track.style.scrollSnapType = 'none';
          if (isForward) {
            track.appendChild(node);
            track.scrollLeft -= w;
          } else {
            track.insertBefore(node, track.firstElementChild);
            track.scrollLeft += w;
          }
          /* Two rAFs — first to let the layout settle with snap-type off,
             second to re-enable snap so the browser doesn't re-snap
             from the old position. */
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              track.style.scrollBehavior = prevBehavior;
              track.style.scrollSnapType = prevSnap;
              isRotating = false;
            });
          });
          return true;
        }
        function rotateForward()        { return domRotate('forward');         }
        function rotateBackward()       { return domRotate('backward');        }
        function rotateBackwardEager()  {        domRotate('eager-backward'); }

        if (rotateLoop) {
          /* Use scrollend when available — the browser fires it exactly
             once per scroll gesture, after all smooth-scroll animation
             has settled. Fallback to a longer debounce (260 ms covers
             default smooth-scroll duration) for older browsers. */
          function onScrollSettled() {
            while (rotateForward())  { /* drain */ }
            while (rotateBackward()) { /* drain */ }
            syncNav();
          }
          if ('onscrollend' in window) {
            track.addEventListener('scrollend', onScrollSettled);
          } else {
            var scrollTimer = null;
            track.addEventListener('scroll', function () {
              if (scrollTimer) clearTimeout(scrollTimer);
              scrollTimer = setTimeout(onScrollSettled, 260);
            }, { passive: true });
          }
        }

        /* Click handlers compute an absolute target position
           (scrollTo) — rapid clicks during an in-flight smooth-scroll
           reliably retarget instead of being dropped by the browser's
           scrollBy-while-animating handling. */
        function targetNext() { return Math.min(track.scrollLeft + step(), track.scrollWidth - track.clientWidth); }
        function targetPrev() { return Math.max(track.scrollLeft - step(), 0); }

        if (prev) prev.addEventListener('click', function () {
          if (rotateLoop && atStart()) {
            rotateBackwardEager();
            track.scrollTo({ left: track.scrollLeft - step(), behavior: 'smooth' });
          } else if (loop && atStart()) {
            track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
          } else {
            track.scrollTo({ left: targetPrev(), behavior: 'smooth' });
          }
        });
        if (next) next.addEventListener('click', function () {
          if (rotateLoop) {
            track.scrollTo({ left: track.scrollLeft + step(), behavior: 'smooth' });
          } else if (loop && atEnd()) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollTo({ left: targetNext(), behavior: 'smooth' });
          }
        });

        /* Autoplay — pauses on hover, focus-within, tab hidden (Page
           Visibility API), and when user-reduced-motion is set.
           Loop ON: never stops (rotateLoop is seamless, scrollTo-wrap
           is visible but functional). Loop OFF: wraps to start.
           Snap-disable trick: scroll-snap-type: x proximity can prevent
           programmatic scrollTo from completing on mobile (the snap
           target gets re-evaluated mid-animation). Disable snap
           temporarily during the smooth-scroll, restore on scrollend. */
        var autoplaySec = parseInt(c.getAttribute('data-tl-autoplay') || '0', 10);
        if (autoplaySec > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          var timer = null;
          function stop()  { if (timer) { clearInterval(timer); timer = null; } }
          function smoothScrollTo(left) {
            var prevSnap = track.style.scrollSnapType;
            track.style.scrollSnapType = 'none';
            track.scrollTo({ left: left, behavior: 'smooth' });
            var restore = function () {
              track.style.scrollSnapType = prevSnap;
              track.removeEventListener('scrollend', restore);
            };
            if ('onscrollend' in window) {
              track.addEventListener('scrollend', restore);
            } else {
              setTimeout(restore, 600);
            }
          }
          function tick() {
            if (rotateLoop) {
              smoothScrollTo(track.scrollLeft + step());
              return;
            }
            if (atEnd()) {
              /* Loop OFF: wrap to start (one-time visible scroll-back).
                 Loop ON without rotateLoop wouldn't reach here. */
              smoothScrollTo(0);
            } else {
              smoothScrollTo(targetNext());
            }
          }
          function play()  { stop(); timer = setInterval(tick, autoplaySec * 1000); }
          c.addEventListener('mouseenter', stop);
          c.addEventListener('mouseleave', play);
          c.addEventListener('focusin',  stop);
          c.addEventListener('focusout', play);
          document.addEventListener('visibilitychange', function () {
            if (document.hidden) stop(); else play();
          });
          play();
        }
      });
    }
    /* Coverflow layout — the cards come from content_for "blocks" (server-
       rendered .shopify-block > .ne-testimonial), so wrap each in a
       .ne-cf__card[data-cf-card] the shared coverflow snippet can drive, then
       (re-)init. The snippet's own DOMContentLoaded scan may already have
       claimed the still-empty .ne-cf (cards weren't wrapped yet); reset the
       __neCf guard so the now-populated stage initialises. */
    function initCfLists(root) {
      (root || document).querySelectorAll('.ne-tl--coverflow[data-coverflow]').forEach(function (cf) {
        if (cf.__tlCfWrapped) return;
        cf.__tlCfWrapped = true;
        var stage = cf.querySelector('[data-cf-stage]');
        if (!stage) return;
        var cardCls = cf.getAttribute('data-cf-card-cls') || 'ne-cf__card';
        var cardRadius = cf.getAttribute('data-cf-card-radius') || '';
        var blocks = Array.prototype.slice.call(stage.children).filter(function (n) {
          return n.nodeType === 1 && !n.hasAttribute('data-cf-card');
        });
        if (!blocks.length) return;
        blocks.forEach(function (block) {
          var wrap = document.createElement('div');
          wrap.className = cardCls;
          wrap.setAttribute('data-cf-card', '');
          if (cardRadius) wrap.style.setProperty('--ne-cf-card-radius', cardRadius + 'px');
          stage.insertBefore(wrap, block);
          wrap.appendChild(block);
        });
        if (window.neInitCoverflows) {
          cf.__neCf = false;
          window.neInitCoverflows(cf.parentElement || document);
        }
      });
    }

    document.addEventListener('DOMContentLoaded', function () { initCarousels(document); initCfLists(document); });
    document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); initCfLists(e.target); });
    document.addEventListener('shopify:block:select', function (e) { initCarousels(e.target); initCfLists(e.target.parentElement || document); });
  })();
  } catch(e) { console.error(e); }
})();

})();
